var exports = {
  "kL": "xa15a2ab7--c19a98--container",
  "Qs": "xa15a2ab7--c19a98--content",
  "o1": "xa15a2ab7--c19a98--actions",
  "XI": "xa15a2ab7--c19a98--action",
  "VH": "xa15a2ab7--c19a98--preview",
};

module.exports = exports;
